




































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import LaporanLosIgd, {
  formatDurasi,
  LosIgdAlasan,
  LosIgdHasil,
  LosIgdKategori,
  LosIgdKategoriTarget,
  LosIgdResponse,
  LosIgdRow,
  LosIgdStatistik
} from "@/services/LaporanLosIgd";

type SaringLos = "semua" | LosIgdKategori | LosIgdHasil;

interface KartuRekapLos {
  kode: LosIgdKategoriTarget | "total";
  judul: string;
  chip: string | null;
  keterangan: string;
  stat: LosIgdStatistik;
  warnaChip: string;
  warnaBar: string;
}

@Component
export default class LaporanLosIgdPage extends Vue {
  data: LosIgdResponse | null = null;
  loading = false;
  printing = false;
  exporting = false;
  permintaan = 0;

  tahun = moment().year();
  bulan = moment().month() + 1;

  cari = "";
  saring: SaringLos = "semua";

  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 }
  ];

  warnaChip: Record<LosIgdKategori, string> = {
    merah: "red lighten-4",
    kuning: "amber lighten-3",
    hijau: "green lighten-4",
    hitam: "grey lighten-1",
    tanpa_kategori: "grey lighten-3"
  };

  warnaBar: Record<LosIgdKategori, string> = {
    merah: "red",
    kuning: "amber darken-1",
    hijau: "green",
    hitam: "grey darken-3",
    tanpa_kategori: "grey"
  };

  warnaHasil: Record<LosIgdHasil, string> = {
    sesuai: "green lighten-4",
    melebihi: "red lighten-4",
    tidak_dihitung: "grey lighten-3"
  };

  headers = [
    { text: "Tanggal", value: "tgl", width: 96 },
    { text: "No. RM", value: "rm", width: 80 },
    { text: "Nama Pasien", value: "nama" },
    { text: "Kategori", value: "kategori", width: 110 },
    { text: "Jam Masuk", value: "jam_masuk", width: 130 },
    { text: "Jam Keluar", value: "jam_keluar", width: 130 },
    { text: "LOS", value: "los_menit", width: 100 },
    { text: "Target", value: "target_menit", width: 70 },
    { text: "Hasil", value: "hasil", width: 120 },
    { text: "Keterangan", value: "keterangan", sortable: false }
  ];

  get tahunOptions(): number[] {
    const kini = moment().year();
    const list: number[] = [];
    for (let t = kini; t >= kini - 5; t--) list.push(t);
    return list;
  }

  get kartuRekap(): KartuRekapLos[] {
    if (!this.data) return [];
    const d = this.data;
    const kartu: KartuRekapLos[] = d.rekap.kategori.map(kat => ({
      kode: kat.kode,
      judul: kat.label,
      chip: kat.prioritas,
      keterangan: `${kat.area} · target ≤ ${formatDurasi(kat.target_menit)}`,
      stat: kat,
      warnaChip: this.warnaChip[kat.kode],
      warnaBar: this.warnaBar[kat.kode]
    }));

    kartu.push({
      kode: "total",
      judul: "Total 3 Kategori",
      chip: null,
      keterangan: `${d.meta.periode.label} · ${d.rekap.jumlah_kunjungan} kunjungan IGD`,
      stat: d.rekap.total,
      warnaChip: "",
      warnaBar: "blue-grey"
    });

    return kartu;
  }

  get daftarTidakDihitung(): {
    kode: LosIgdAlasan;
    label: string;
    jumlah: number;
  }[] {
    if (!this.data) return [];
    const d = this.data;
    return (Object.keys(d.rekap.dikecualikan) as LosIgdAlasan[])
      .filter(kode => d.rekap.dikecualikan[kode] > 0)
      .map(kode => ({
        kode,
        label: d.referensi.alasan[kode],
        jumlah: d.rekap.dikecualikan[kode]
      }));
  }

  get jumlahTidakDihitung(): number {
    return this.daftarTidakDihitung.reduce((t, x) => t + x.jumlah, 0);
  }

  get perluDilengkapi(): boolean {
    if (!this.data) return false;
    const d = this.data.rekap.dikecualikan;
    return d.tanpa_kategori > 0 || d.belum_keluar > 0;
  }

  get opsiSaring(): { text: string; value: SaringLos; jumlah: number }[] {
    const rows = this.data ? this.data.rows : [];
    const hitung = (fn: (r: LosIgdRow) => boolean) => rows.filter(fn).length;

    return [
      { text: "Semua", value: "semua", jumlah: rows.length },
      {
        text: "Merah",
        value: "merah",
        jumlah: hitung(r => r.kategori === "merah")
      },
      {
        text: "Kuning",
        value: "kuning",
        jumlah: hitung(r => r.kategori === "kuning")
      },
      {
        text: "Hijau",
        value: "hijau",
        jumlah: hitung(r => r.kategori === "hijau")
      },
      {
        text: "Melebihi target",
        value: "melebihi",
        jumlah: hitung(r => r.hasil === "melebihi")
      },
      {
        text: "Tidak dihitung",
        value: "tidak_dihitung",
        jumlah: hitung(r => r.hasil === "tidak_dihitung")
      }
    ];
  }

  get barisTersaring(): LosIgdRow[] {
    if (!this.data) return [];
    const s = this.saring;
    if (s === "semua") return this.data.rows;
    if (s === "melebihi" || s === "tidak_dihitung" || s === "sesuai") {
      return this.data.rows.filter(r => r.hasil === s);
    }
    return this.data.rows.filter(r => r.kategori === s);
  }

  mounted(): void {
    this.muat();
  }

  kembali(): void {
    this.$router.push({ name: "laporan-igd-menu" }).catch(() => undefined);
  }

  async muat(): Promise<void> {
    const nomor = ++this.permintaan;
    this.loading = true;
    const res = await LaporanLosIgd.get({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => null);
    if (nomor !== this.permintaan) return;
    this.data = res;
    this.saring = "semua";
    this.loading = false;
  }

  async cetak(): Promise<void> {
    this.printing = true;
    await LaporanLosIgd.openPdf({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => undefined);
    this.printing = false;
  }

  async unduh(): Promise<void> {
    this.exporting = true;
    await LaporanLosIgd.downloadExcel({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => undefined);
    this.exporting = false;
  }

  angkaKartu(stat: LosIgdStatistik): { label: string; nilai: string }[] {
    return [
      { label: "Melebihi target", nilai: `${stat.melebihi} pasien` },
      { label: "Rata-rata LOS", nilai: formatDurasi(stat.rata_menit) },
      { label: "Median LOS", nilai: formatDurasi(stat.median_menit) },
      { label: "LOS terlama", nilai: formatDurasi(stat.maks_menit) }
    ];
  }

  persen(nilai: number | null): string {
    return nilai === null ? "–" : `${nilai.toLocaleString("id-ID")}%`;
  }

  durasi(menit: number | null): string {
    return formatDurasi(menit);
  }

  tanggal(tgl: string): string {
    return moment(tgl, "YYYY-MM-DD").format("DD-MM-YYYY");
  }

  jam(nilai: string | null): string {
    return nilai ? moment(nilai, "YYYY-MM-DD HH:mm").format("DD-MM HH:mm") : "-";
  }
}
